import React from 'react';
import { Container, StyledOverlay, OutlineButton } from './download-overlay.styled';
var DownloadOverlay = function DownloadOverlay(_ref) {
    var url = _ref.url, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Download' : _ref$label, children = _ref.children;
    return /*#__PURE__*/ React.createElement(Container, null, children, /*#__PURE__*/ React.createElement(StyledOverlay, null, /*#__PURE__*/ React.createElement(OutlineButton, {
        width: 6.25,
        height: 2.25,
        label: label,
        onClick: function onClick() {
            return window.open(url);
        }
    })));
};
export default DownloadOverlay;
